import { render } from "./Seguro.vue?vue&type=template&id=7c7f06ba&scoped=true"
import script from "./Seguro.vue?vue&type=script&lang=js"
export * from "./Seguro.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=7c7f06ba&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7f06ba"]])

export default __exports__